import React, {useState} from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'


export const RentalPopupContainer = styled.div`
    position: absolute;
    display: ${(props) => props.display};
    flex-direction:column;
    top: 107px;
    right: 233px;
    border-radius: 10px;
    background-color: #262626 ;
    width:400px;
    margin-top:30px;
    align-items:center;
    z-index: 1;
`
export const RentalPopupWrapper = styled.div`
    color: white;
    margin: 0px 32px;
    display:flex;
    flex-direction:column;
`
export const RentalPopupHead = styled.div`
    display: flex;
    margin: 10px 32px 10px 32px;
    font-size:20px;
    font-weight:bold;

`
export const RentalPopupContent = styled.div`
    margin:0px 22px 10px 22px;
`
export const RentalPopupTrack = styled.div`
    /* height: 106px; */
    background-color:black;
    width: 358px;
    border-radius: 10px;
    margin: 10px;
    padding: 10px;
`
export const RentalTrackHead = styled.div`
    display: flex;
    justify-content:space-between;
`

export const RentalName = styled.div`
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
    display: flex;
    align-items:center;
`
export const RentalTrackFooter = styled.div`
    font-size: 12px;
    line-height: 15px;
    color: #8c8c8c;
`
export const RentalAvailable = styled.div`
    font-size: 12px;
    line-height: 15px;
    color: #8c8c8c;

`
export const RentalPercentage = styled.div`
    color: #40a9ff;
    font-size: 12px;
    line-height: 15px;

`
export const Progress = styled.div`
    width: 100%;
    height: 5px;
    background: #262626;
    border-radius: 10px;
    overflow: hidden;
    display:flex;
    margin: 10px 0px;
`
export const ProgressFill = styled.div`
    width: ${(props) => props.progress};
    height: 100%;
    background: #389e0d;
    border-radius:10px;
    
`



const RentalsPopup = ({display}) => {
    const { t } = useTranslation()
    const [progress, setProgress] = useState(40);
    const remain =  60 - progress
    const progressPercent = Math.ceil((progress * 100)/60) + '%'
    console.log(progressPercent);

  return (
    <>
        <RentalPopupContainer display= {display}>
            <RentalPopupWrapper>
                <RentalPopupHead>{t("RentalPopup.caption")}</RentalPopupHead>
                <RentalPopupContent>
                    <RentalPopupTrack>
                        <RentalTrackHead>
                            <RentalName>Bomber Pants</RentalName>
                            <RentalPercentage>{progressPercent}</RentalPercentage>
                            {/* <RentalAvailable></RentalAvailable> */}
                        </RentalTrackHead>
                            <Progress>
                                <ProgressFill progress={progressPercent}></ProgressFill>
                            </Progress>
                            <RentalTrackFooter>{progress}/60 Days Played. {remain}/60 Playable Days Remaining</RentalTrackFooter>
                    </RentalPopupTrack>
                    <RentalPopupTrack>
                        <RentalTrackHead>
                            <RentalName>Bomber Pants</RentalName>
                            <RentalAvailable>100%. Available For Rental</RentalAvailable>
                        </RentalTrackHead>
                            <Progress>
                                <ProgressFill></ProgressFill>
                            </Progress>
                            <RentalTrackFooter></RentalTrackFooter>
                    </RentalPopupTrack>
                    <RentalPopupTrack>
                        <RentalTrackHead>
                            <RentalName>Bomber Pants</RentalName>
                            <RentalAvailable>100%. Available For Rental</RentalAvailable>
                        </RentalTrackHead>
                            <Progress>
                                <ProgressFill></ProgressFill>
                            </Progress>
                            <RentalTrackFooter></RentalTrackFooter>
                    </RentalPopupTrack>
                    <RentalPopupTrack>
                        <RentalTrackHead>
                            <RentalName>Bomber Pants</RentalName>
                            <RentalAvailable>100%. Available For Rental</RentalAvailable>
                        </RentalTrackHead>
                            <Progress>
                                <ProgressFill></ProgressFill>
                            </Progress>
                            <RentalTrackFooter></RentalTrackFooter>
                    </RentalPopupTrack>
                </RentalPopupContent>
            </RentalPopupWrapper>
        </RentalPopupContainer>
    </>
  )
}

export default RentalsPopup